import { render, staticRenderFns } from "./CreateLevelView.vue?vue&type=template&id=22d07c9f&scoped=true"
import script from "./CreateLevelView.vue?vue&type=script&lang=js"
export * from "./CreateLevelView.vue?vue&type=script&lang=js"
import style0 from "./CreateLevelView.vue?vue&type=style&index=0&id=22d07c9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d07c9f",
  null
  
)

export default component.exports